// Dependencias entre permisos en la pantalla Usuarios (H24). El catálogo del backend
// declara qué necesita cada unidad (Ventas necesita Clientes y «Productos (lectura)»):
// sin esto se podía dejar a un Operador con Ventas y sin productos, y su buscador de
// la venta quedaba vacío. `requires` = {código: [lecturas que necesita]} y
// `unitLabels` = {código: nombre de su unidad}, tal como los manda listSubUsers.

// Selección completada con lo que necesita, y {código bloqueado: quién lo necesita}.
export function applyDependencies(selected, requires, unitLabels, grantable) {
    const offered = new Set((grantable || []).map(g => g.code));
    const codes = [...new Set(selected || [])];
    const locked = {};
    for (const code of codes) {
        for (const needed of (requires && requires[code]) || []) {
            if (!offered.has(needed)) continue;
            if (!codes.includes(needed)) codes.push(needed);
            if (!locked[needed]) locked[needed] = (unitLabels && unitLabels[code]) || code;
        }
    }
    return { codes, locked };
}
